import React, { useEffect, useState } from "react";
import Table from "../../components/Table";
import Layout from "../../layout/Layout";
// import { getOperations } from "../../services/operationImmobilier";
import { getOperationImmobilieres } from "../../services/operationImmobilier";
import {
  deleteIlot,
  updateIlot,
  getIlots,
  createIlot
} from "../../services/ilots";
import ReactPaginate from "react-paginate";
import Loading from "../../components/Loading";
import Alert from "../../components/Alert";

const Ilots = () => {
  const headTable = [{ name: "Libellé", width: "95%" }, { name: "", with: "5%" },];
  const [current, setCurrent] = useState(null);

  const forms = [
    {
      label: "Libelle",
      type: "text",
      name: "libelle",
      values: current?.LIBELLE ?? "",
    },
  ];
  //pagination
  const [ilots, setIlots] = useState([]);
  // const [current, setCurrent] = useState(null);
  const [operationImmobilieres, setOperationImmobilieres] = useState([]);
  const [values, setValues] = useState({
    idoperationimmo: "",
    libelle: "",
  });


  const fetchIlots = () => {
    setIsLoading(true);
    getOperationImmobilieres()
      .then(({ data }) => {
        setOperationImmobilieres(data.data);
        setIsLoading(false);
        // setIlots(data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // pagination code
  const [flash, setFlash] = useState({ message: null, color: "success" });

  // pagination code
  let PageSize = 10;
  const [isLoading, setIsLoading] = useState(false);
  const [currentTableData, setCurrentTableData] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [totalPage, setTotalPage] = useState(null);
  const page = (currentPage, datas) => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;

    return datas.slice(firstPageIndex, lastPageIndex);
  };

  const onPageChange = (e) => {
    const d = page(parseInt(e.selected + 1), tableData);
    setCurrentTableData(d);
    // console.log(d);
  };
  // fin code pagination

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const onSelectOperationImmobiliere = async (e) => {
    setCurrentTableData([]);
    setValues({ ...values, idoperationimmo: e.target.value });
    getIlots({ idoperationimmo: e.target.value })
      .then((res) => {
        const { data, message } = res;
        const d = page(1, data.data);
        // setRubrique(data)
        setCurrentTableData(data.data);
        const coutPage = parseInt(data.data.length / PageSize);
        setTotalPage(coutPage);
        setTableData(data);
        setFlash({ ...flash, message: res.data.message, color: "success" });
        // setRubrique(data);
      })
      .catch((err) => {
        // console.log(err);
      });

  };
  //fin de paginatio;
  // const handleChange = (e) => {
  //   setValues({ ...values, [e.target.name]: e.target.value });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(false);
    // console.log(isLoading);
    if (current) {

      let data = { ...values, id: current?.ID };
      if (data.idoperationimmo.length === 0 || data.libelle.length === 0 || data.id.length === 0) {
        setFlash({ message: "Veuillez saisir les champs requis", color: "danger" });
        setIsLoading(false);
        return false;
      }
      updateIlot(data)
        .then((res) => {
          setFlash({ ...flash, message: res.data.message, color: "success" });
          setIsLoading(false);
          setValues({ ...values, libelle: "" });
          setCurrent(null);
          getIlots({ idoperationimmo: values.idoperationimmo })
            .then((res) => {
              console.log(res);
              const { data } = res;
              const d = page(1, data.data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.data.length / PageSize);
              setTotalPage(coutPage);
              setTableData(data);
              setFlash({ ...flash, message: "Liste des ilots par operation", color: "success" });
              setIsLoading(false);
              setValues({ ...values, libelle: "" });
            })
            .catch((err) => {
              console.log(err);
            });
        })
    } else {
      if (values.idoperationimmo.length === 0 || values.libelle.length === 0) {
        setFlash({ message: "Veuillez saisir les champs requis", color: "danger" });
        setIsLoading(false);
        return false;
      }
      createIlot(values)
        .then((res) => {
          setFlash({ ...flash, message: res.data.message, color: "success" });
          setValues({ ...values, libelle: "" });
          setIsLoading(false);
          getIlots({ idoperationimmo: values.idoperationimmo })
            .then((res) => {
              console.log(res);
              const { data } = res;
              const d = page(1, data.data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.data.length / PageSize);
              setTotalPage(coutPage);
              setTableData(data);
              setFlash({ ...flash, message: "Liste des ilots par operation", color: "success" });
              setIsLoading(false);
              setValues({ ...values, libelle: "" });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((res) => {
          //  console.log(err)
          setFlash({ message: res.data.message, color: "danger" });
        });
    }
  };
  // delete
  const onclick = (data) => {
    setCurrent(data);
    setValues({ ...values, idoperationimmo: data.IDOPERATIONIMMO, libelle: data.LIBELLE });
  };

  const onDelete = async () => {
    if (window.confirm("Etre vous sur de vouloir supprimer le ilot?")) {
      const data = { id: current.ID, libelle: current.LIBELLE };
      deleteIlot(data)
        .then(({ data }) => {
          setIsLoading(true);
          setCurrent(null);
          setFlash({ ...flash, message: data.message });
          getIlots({ idoperationimmo: values.idoperationimmo })
            .then((res) => {
              const { data } = res;
              const d = page(1, data.data);
              setIlots(data.data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.data.length / PageSize);
              // console.log(coutPage);
              setTotalPage(coutPage);
              setIsLoading(false);
            })
            .catch((err) => {
              setIsLoading(false)
              setIsLoading(true);
              console.log(err);
            });
        })
        .catch((error) => {
          // console.log(error.response);
          setIsLoading(false);
          setCurrent(null);
          setFlash({
            ...flash,
            color: "danger",
            message: error.response.data.message,
          });
        });
    }
  };

  useEffect(() => {
    fetchIlots();
  }, []);
  return (
    <Layout>
      <div className="row">
        <div className="col-xs-2" />
        <form onSubmit={handleSubmit}>
          <div className="form-horizontal col-xs-8 ui-sortable">
            <div className="widget-box widget-color-blue">
              {/* Entete du cadre */}
              <div className="widget-header ui-sortable-handle">
                <h5 className="widget-title">Saisie des ilots</h5>
              </div>
              {/* Contenu du cadre */}
              <div className="widget-body">
                <div className="widget-main">
                  {flash?.message !== null && (
                    <Alert color={flash?.color} message={flash?.message} />
                  )}
                  <span
                    id="ContentPlaceHolder1_LBINFO"
                    style={{
                      display: "inline-block",
                      width: "100%",
                      textAlign: "center",
                    }}
                  />

                  {/* code form */}
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Operation (*)
                    </label>
                    <select
                      name="idoperation"
                      className="form-control input-xxlarge"
                      onChange={onSelectOperationImmobiliere}
                    >
                      <option value="-1"></option>
                      {operationImmobilieres?.map((item, key) => (
                        <option key={key} value={item.ID}>
                          {item.LIBELLE}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Libéllé (*)
                    </label>
                    <input
                      value={values.libelle}
                      onChange={handleChange}
                      name="libelle"
                      type="text"
                      className="form-control input-xxlarge"
                    />
                  </label>
                </div>
                {/* Pied du cadre */}
                <div className="widget-toolbox padding-8 clearfix">
                  <div className="pull-right">
                    <input
                      type="submit"
                      value="Enregistrer"
                      className="btn btn-success "
                      disabled={isLoading ? true : false}
                      style={{
                        borderStyle: "None",
                        width: 100,
                        marginRight: 2,
                        marginBottom: 2,
                      }}
                    />

                    {current && (
                      <input
                        type="button"
                        value="Supprimer"
                        className="btn btn-danger"
                        onClick={onDelete}
                        style={{
                          borderStyle: "None",
                          width: 100,
                          marginRight: 2,
                          marginBottom: 2,
                        }}
                      />
                    )}
                    <input
                      type="button"
                      value="Annuler"
                      className="btn btn-warning"
                      style={{
                        borderStyle: "None",
                        width: 100,
                        marginBottom: 2,
                      }}
                      onClick={() => {
                        setCurrent(null);
                        setValues({ ...values, libelle: "" });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {isLoading ? (
        <Loading isLoading={isLoading} />
      ) : (
        <Table title={"Liste des ilots"} headTable={headTable}>
          {currentTableData?.map((item, key) => (
            <tr key={key} style={{ color: "Black", backgroundColor: "White" }}>
              <td>{item.LIBELLE}</td>
              <td className="text-center" align="right">
                <img
                  onClick={() => onclick(item)}
                  style={{ width: 15, height: 10 }}
                  src={"/Catef_files/modifier.png"}
                />
              </td>
            </tr>
          ))}
          {/* pgination */}
          <tr
            className="pagination-od"
            align="center"
            style={{
              color: "Black",
              backgroundColor: "#EFF3F8",
              fontWeight: "normal",
              whiteSpace: "nowrap",
            }}
          >
            <td colSpan={5}>
              {totalPage != null && (
                <ReactPaginate
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  breakLabel="..."
                  nextLabel="suivant >"
                  onPageChange={onPageChange}
                  pageRangeDisplayed={5}
                  pageCount={totalPage + 1}
                  previousLabel="< précédent"
                  renderOnZeroPageCount={null}
                />
              )}
            </td>
          </tr>
        </Table>
      )}
    </Layout>
  );
};

export default Ilots;
